import React, { useEffect as uEffect } from 'react'

import { useState as uState } from "react";
import "../chart.scss";
import {
Bar,BarChart,Legend,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from "recharts";

export default function ordersBarChart({ aspect, title }) {
    const [monthOrders, setMonthOrders] = uState("")
    const [monthOrders2, setMonthOrders2] = uState("");
    const [monthOrders3, setMonthOrders3] = uState("");
    const [monthOrders4, setMonthOrders4] = uState("");
    const [monthOrders5, setMonthOrders5] = uState("");
    const [monthOrders6, setMonthOrders6] = uState("");


    var currentDate = new Date(); // get the current date

    var dates = [];

    for (var i = 0; i < 6; i++) {
        // loop through the previous six months
        var previousMonth = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() - i
        ); // get the date object for the previous month
        var monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        var previousMonthName = monthNames[previousMonth.getMonth()]; // get the name of the previous month
        var previousMonthYear = previousMonth.getFullYear(); // get the year of the previous month

        // if the previous month is in the previous year, subtract 1 from the year
        if (previousMonth.getMonth() > currentDate.getMonth()) {
            previousMonthYear -= 0;
        }

        var obj = { name: previousMonthName, Year: previousMonthYear }; // create an object with the name of the month and the year
        dates.push(obj); // add the object to the data array
    }


    const month1 = async() => {

        await fetch("http://localhost:8000/order/ordrsMonth", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(),
        })
            .then(async(response) =>await response.json())
            .then((data) => setMonthOrders(data)
            );
    }
    const month2 = async() => {

        await fetch("http://localhost:8000/order/ordrsMonth2", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(),
        })
            .then(async(response) =>await response.json())
            .then((data) => setMonthOrders2(data));
    }
    const month3 =  async() => {

         await fetch("http://localhost:8000/order/ordrsMonth3", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(),
        })
            .then(async(response) =>await  response.json())
            .then((data) => setMonthOrders3(data));
    }
    const month4 =  async() => {

        await fetch("http://localhost:8000/order/ordrsMonth4", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(),
        })
            .then( async(response) =>await response.json())
            .then((data) => setMonthOrders4(data));
    }
    const month5 = async() => {

        await fetch("http://localhost:8000/order/ordrsMonth5", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(),
        })
            .then(async(response) =>await response.json())
            .then((data) => setMonthOrders5(data));
    }
    const month6 = async () => {
        
        await fetch("http://localhost:8000/order/ordrsMonth6", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(),
        })
            .then(async(response) =>await response.json())
            .then((data) => setMonthOrders6(data));
    }
    uEffect(() => {
        month1()
        month2()
        month3()
        month4()
        month5()
        month6()
    }, [])

    const fetchData = [
        { name: dates[5].name, Year: dates[5].Year, Orders: monthOrders6 },
        { name: dates[4].name, Year: dates[4].Year, Orders: monthOrders5 },
        { name: dates[3].name, Year: dates[3].Year, Orders: monthOrders4 },
        { name: dates[2].name, Year: dates[2].Year, Orders: monthOrders3 },
        { name: dates[1].name, Year: dates[1].Year, Orders: monthOrders2 },
        { name: dates[0].name, Year: dates[0].Year, Orders: monthOrders },
    ];
  return (
      <>
      

          <div className="chart">
              <div className="title">{title}</div>
                  <BarChart width={630} height={280} data={fetchData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis dataKey="Orders" />
                      <Tooltip />
                      <Legend />
                  <Bar dataKey="Orders" fill="#046A38" />
                  </BarChart>
          </div>
      
      
      
      </>
  )
}
